export default __webpack_public_path__ + "static/media/slide11.1eac8d13.webp";